import React from "react"
import { FastField } from "formik"

function PickupList({ pickupAddressList, selectedValue }) {
  return (
    <>
      <h3>Pick-up Location</h3>
      {pickupAddressList &&
        pickupAddressList.length > 0 &&
        pickupAddressList.map((add, i) => (
          <span key={add.id} className="radio">
            <FastField
              name="pickUpAddress"
              id={add.id}
              type="radio"
              value={add.id}
              checked={Number(selectedValue) === Number(add.id)}
            />
            <label htmlFor="pickUpAddress">
              {`${(add.address.address_line_1 &&
                add.address.address_line_1 + ", ") ||
                ""}
              ${(add.address.address_line_2 &&
                add.address.address_line_2 + ", ") ||
                ""}
              ${(add.address.barangay && add.address.barangay + ", ") || ""}
              ${(add.address.city && add.address.city + ", ") || ""}
              ${(add.address.zipcode && add.address.zipcode + ", ") || ""}
              ${(add.address.province && add.address.province + ", ") || ""}
              ${(add.address.country && add.address.country) || ""}`}
            </label>
          </span>
        ))}
    </>
  )
}

export default PickupList
